import { enGB, he, de } from 'date-fns/locale';
import { LOCALE } from '../constants';

const locales = { en: enGB, he, de };

export function getDateFnsLocale() {
  return locales[LOCALE as keyof typeof locales] || locales.en;
}
